import { css } from 'lit';
import { hostReset, focusRing } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  focusRing('.uwc-rating__star',   '--uwc-color-primary', '#6366f1'),
  focusRing('.uwc-rating__cancel', '--uwc-color-primary', '#6366f1'),
  css`
    :host {
      display: inline-block;
    }

    /* ── Container ───────────────────────────────────────────────────── */
    .uwc-rating {
      display:     inline-flex;
      align-items: center;
      gap:         var(--uwc-rating-gap, 0.125rem);
    }

    /* ── Star / cancel buttons ───────────────────────────────────────── */
    .uwc-rating__star,
    .uwc-rating__cancel {
      display:         inline-flex;
      align-items:     center;
      justify-content: center;
      background:      transparent;
      border:          none;
      padding:         var(--uwc-rating-padding, 0.25rem);
      cursor:          pointer;
      border-radius:   ${t.radiusSm};
      color:           var(--uwc-rating-off-color, ${t.textMuted});
      transition:      color ${t.durationBase}, transform ${t.durationFast};
      line-height:     1;
    }

    /* ── SVG sizes ───────────────────────────────────────────────────── */
    .uwc-rating__star svg,
    .uwc-rating__cancel svg {
      width:  1.35rem;
      height: 1.35rem;
      display: block;
    }
    :host([size="small"]) .uwc-rating__star svg,
    :host([size="small"]) .uwc-rating__cancel svg { width: 1rem;   height: 1rem;   }
    :host([size="large"]) .uwc-rating__star svg,
    :host([size="large"]) .uwc-rating__cancel svg { width: 1.75rem; height: 1.75rem; }

    /* ── Filled / active state ───────────────────────────────────────── */
    .uwc-rating__star[aria-checked="true"] {
      color: var(--uwc-rating-on-color, ${t.warning});
    }

    /* Hover preview on stars (not readonly / disabled) */
    :host(:not([readonly]):not([disabled])) .uwc-rating__star.is-preview {
      color: var(--uwc-rating-hover-color, ${t.warning});
    }

    :host(:not([readonly]):not([disabled])) .uwc-rating__star:hover,
    :host(:not([readonly]):not([disabled])) .uwc-rating__star.is-preview {
      transform: scale(1.2);
    }

    /* Cancel button */
    .uwc-rating__cancel {
      color: var(--uwc-rating-cancel-color, ${t.textMuted});
    }
    :host(:not([readonly]):not([disabled])) .uwc-rating__cancel:hover {
      color:     var(--uwc-rating-cancel-hover-color, ${t.danger});
      transform: scale(1.2);
    }

    /* ── Separator between cancel and stars ──────────────────────────── */
    .uwc-rating__sep {
      width:      1px;
      height:     1.1rem;
      background: var(--uwc-rating-sep-color, ${t.borderControl});
      margin:     0 0.25rem;
      flex-shrink: 0;
    }

    /* ── Readonly ────────────────────────────────────────────────────── */
    :host([readonly]) .uwc-rating__star,
    :host([readonly]) .uwc-rating__cancel {
      cursor:         default;
      pointer-events: none;
    }

    /* ── Disabled ────────────────────────────────────────────────────── */
    :host([disabled]) .uwc-rating {
      opacity:        0.5;
      pointer-events: none;
    }

    @media (prefers-reduced-motion: reduce) {
      .uwc-rating__star,
      .uwc-rating__cancel { transition: none; }
    }
  `,
];
